import React, { useState, useEffect } from 'react';
import { Table } from 'react-unity';
import DoNotDecryptRule from '../../models/entities/DoNotDecryptRule';				
import SubscriptionRequest from '../../models/entities/SubscriptionRequest';
import { DoNotDecryptRequestsDirection } from '../../models/enums/DNDR/DoNotDecryptRequestsDirection';
import Paginator from '../common/tables/Paginator';
import { DNDRColumn, RuleColumnsLayout } from './components/RuleColumnsLayout';
import DoNotDecryptRequestsByRuleRow from './DoNotDecryptRequestsByRuleRow';
import DNDRByRuleFilters from './DNDRByRuleFilters';
import { VirtualNetwork } from '../../models/entities/AzureResources/VirtualNetwork';

interface DoNotDecryptRequestsByRuleProps {
	subscription: SubscriptionRequest;
	rules: DoNotDecryptRule[];				
	validVnets: VirtualNetwork[];
}

const DoNotDecryptRequestsByRule = ({ subscription, rules, validVnets }: DoNotDecryptRequestsByRuleProps) => {
	const [visibleRules, setVisibleRules] = useState<DoNotDecryptRule[]>([]);				
	const [columns, setColumns] = useState<DNDRColumn[]>(
		RuleColumnsLayout.get(
			new DoNotDecryptRequestsDirection().fromName(DoNotDecryptRequestsDirection.SubscriptionToInternet.name)
		)
	);
	const [filteredRules, setFilteredRules] = useState(rules.filter(rule => rule.direction.name === DoNotDecryptRequestsDirection.SubscriptionToInternet.name));
	const [selectedRules, setSelectedRules] = useState<DoNotDecryptRule[]>([]);				

	const getHeaders = () => {
		return columns.map((column) => <Table.Head.Cell key={column.header}>{column.header}</Table.Head.Cell>);
	};

	const changeSelectedRules = (rule) => {
		if (selectedRules.some((selectedRule) => selectedRule.id === rule.id)) {
			setSelectedRules(selectedRules.filter((selectedRule) => selectedRule.id !== rule.id));
			return;
		}
		setSelectedRules([...selectedRules, rule]);
	}

	return (
		<>
			<Table
				header={
					<DNDRByRuleFilters
						columns={columns}
						rules={rules}
						onFilterChange={setFilteredRules}
						changeColumns={setColumns}
						subscriptionId={subscription.id}
						rulesFilteredForCSVCreation={filteredRules}
						resetSelectedRules={() =>setSelectedRules([])}
						selectedRules={selectedRules}
					/>
				}
				footer={<Paginator data={filteredRules} onPageChange={(page) => setVisibleRules(page)} />}
			>
				<Table.Head>
					<Table.Head.Row>
						<Table.Head.Cell></Table.Head.Cell>
						{getHeaders()}
						<Table.Head.Cell> </Table.Head.Cell>
					</Table.Head.Row>
				</Table.Head>
				<Table.Body>
					{visibleRules.map((rule, ruleIndex) => (
						<DoNotDecryptRequestsByRuleRow
							key={rule.id}
							rule={rule}
							indexOnList={filteredRules.indexOf(rule) + 1}
							columns={columns}
							ruleIndex={ruleIndex}
							selectedRules={selectedRules}
							onChangeSelectedRules={changeSelectedRules}
							subscriptionRequestName={subscription.createdSubscriptionName}
							validVnets={validVnets}
						/>
					))}
				</Table.Body>
			</Table>
		</>
	);
};

export default DoNotDecryptRequestsByRule;
